export const MODULE_KEY = 'cart';

export const ADDRESS_TYPES = ['shipping', 'billing'];
export const ADDRESS_FIELDS = [
    ['[firstname]', 'firstName'],
    ['[lastname]', 'lastName'],
    ['[telephone]', 'phone'],
    ['[email]', 'email'],
    ['[country_id]', 'country'],
    ['[city]', 'city'],
    ['[postcode]', 'postcode'],
    ['[region]', 'region'],
    ['[street][]', 'street'],
    ['[region_id]', 'regionId'],
];
